module.exports = __webpack_public_path__ + "img/guillermo-colombo.c741d702.png";